import { render, staticRenderFns } from "./TextureLoading.vue?vue&type=template&id=571a567c&scoped=true"
import script from "./TextureLoading.vue?vue&type=script&lang=js"
export * from "./TextureLoading.vue?vue&type=script&lang=js"
import style0 from "./TextureLoading.vue?vue&type=style&index=0&id=571a567c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a567c",
  null
  
)

export default component.exports